const comments = [
  {
    name: '电影爱好者小陈',
    text: '成全影院真的太良心了！片源齐全画质又好，追剧神器。每天下班回家第一件事就是打开看看更新了什么新片，强烈推荐！',
    time: '2天前',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20style%20avatar%20with%20soft%20amber%20lighting%2C%20elegant%20dark%20background%2C%20professional%20headshot%20aesthetic%2C%20warm%20golden%20tones&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '追剧小天后',
    text: '这个站更新速度真的快，热播剧基本同步上线。高清不卡顿不是吹的，比很多收费网站体验都好，成全影院 yyds！',
    time: '1天前',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20portrait%20style%20avatar%2C%20soft%20golden%20hour%20lighting%2C%20elegant%20dark%20background%2C%20sophisticated%20headshot%2C%20rich%20amber%20hues&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '悬疑控小李',
    text: '作为一个悬疑片爱好者，成全影院的悬疑推理分类做得特别好，冷门好片也能找到。感谢平台用心整理！',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20portrait%20with%20deep%20warm%20shadows%2C%20amber%20key%20light%2C%20dark%20elegant%20background%2C%20film%20noir%20style%20headshot%2C%20rich%20brown%20and%20golden%20tones&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    name: '科幻迷阿杰',
    text: '科幻区的资源整理得很全，从经典老片到最新大片都有。画质清晰，加载速度也很快，成全影院已经成为我的主力观影站。',
    time: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20headshot%20portrait%20with%20soft%20golden%20rim%20lighting%2C%20dark%20toned%20background%2C%20professional%20aesthetic%2C%20rich%20amber%20and%20copper%20tones&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
  {
    name: '综艺达人圆圆',
    text: '综艺节目更新太及时了！而且整理了综艺大全最新影片专区，找起来特别方便。全家都爱看成全影院。',
    time: '4天前',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20cinematic%20portrait%20with%20warm%20golden%20backlight%2C%20elegant%20dark%20background%2C%20sophisticated%20headshot%20style%2C%20rich%20amber%20lighting%2C%20warm%20atmospheric%20mood&width=80&height=80&seq=avatar-05&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              观众热评
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              观众都在说什么
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              来自真实用户的观影心声
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {comments.map((c, i) => (
              <article key={i} className={`bg-background-50 rounded-xl p-5 border border-background-200/70 ${i === 0 ? 'lg:col-span-2' : ''}`}>
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900">{c.name}</h3>
                    <p className="text-xs text-foreground-400">{c.time}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
                <div className="flex items-center gap-1 mt-3">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-accent-400 text-xs w-4 h-4 flex items-center justify-center"></i>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}